<template>
  <main>
    <form @submit.prevent="login">
      <p v-if="error">
        <em>{{ error }}</em>
      </p>

      <div class="input-group">
        <label for="email">Email:</label>
        <input id="email" type="email" v-model="email" required />
      </div>

      <div class="input-group">
        <label for="password">Password:</label>
        <input id="password" type="password" v-model="password" required />
      </div>

      <button type="submit">Login</button>
    </form>
  </main>
</template>

<script>
export default {
  name: 'login',

  data() {
    return {
      email: '',
      password: '',
      error: '',
    };
  },

  methods: {
    async login() {
      const email = this.email;
      const password = this.password;
      let response;

      try {
        response = await this.$http.post('/auth/login', { email, password });
      } catch (error) {
        this.error = error.response.data.message;

        return;
      }

      const { user, token } = response.data;
      this.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
      this.$store.commit('setUserData', user);
      this.$store.commit('setAuthToken', token);
      this.$router.push({ name: 'reporting' });
    },
  },
};
</script>
